export default {"src":"/_next/static/media/1.1a4329a0.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};